import { PublicationCardItem } from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import React, { FC } from 'react'
import { ThemedRender } from '../../../__styling/themed-render'
import {
    StyledListCardKicker,
    StyledNightlyTopicLabel,
    StyledTopicLabel,
} from '../ListCard.styled'

interface ListCardTopicTagProps {
    item: MaybeLoaded<PublicationCardItem>
    level?: 'parent'
}

export const ListCardTopicTag: FC<ListCardTopicTagProps> = (props) => {
    const { item, level } = props

    if (!item || !item.loaded) {
        return null
    }

    const topic = item.result.primaryTopic
    const text = item.result.primaryTopic.title

    return (
        <ThemedRender
            perthnow={() => <StyledTopicLabel topic={topic} text={text} />}
            sevennews={() => (
                <StyledListCardKicker>
                    {item.result.kicker}
                </StyledListCardKicker>
            )}
            thenightly={() => (
                <StyledNightlyTopicLabel>
                    {level === 'parent' ? topic.parent?.title ?? text : text}
                </StyledNightlyTopicLabel>
            )}
        />
    )
}
ListCardTopicTag.displayName = 'ListCardTopicTag'
